/* eslint-disable no-console */
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import {
  isTestFullSteamDigitalWallet,
  isTestFullSteamDigitalWalletForBetaCustomers
} from 'common/helpers/featureFlags';
import { useComponentWillMount } from 'common/helpers/hooks';
import { hasCommerce7Payments } from 'common/helpers/paymentHelper';

import APIError from '../apiError/APIError';

const Layout = (props) => {
  const { title, children, description } = props;

  const handleMount = () => {
    const c7Content = document.getElementById('c7-content');
    c7Content.style.minHeight = 0;

    c7Content.className = 'c7-content--checkout';
    c7Content.removeAttribute('style');
    c7Content.style.padding = '0';
    c7Content.style.position = 'fixed';
    c7Content.style.top = '0';
    c7Content.style.left = '0';
    c7Content.style.height = '100%';
    c7Content.style.width = '100%';
    c7Content.style.zIndex = 9999;
    c7Content.style.overflowY = 'scroll';
    c7Content.style.WebkitOverflowScrolling = 'touch';
  };

  useComponentWillMount(handleMount);

  const settings = useSelector((state) => state.setting.data);

  const { companyName } = settings;

  let seoTitle = companyName;
  if (title) {
    seoTitle = `${title} | ${companyName}`;
  }

  const isFullSteamDigitalWalletEnabled =
    (isTestFullSteamDigitalWallet() ||
      isTestFullSteamDigitalWalletForBetaCustomers()) &&
    hasCommerce7Payments(settings);

  useEffect(() => {
    if (isFullSteamDigitalWalletEnabled) {
      import('../fullSteamMobileWallet/scripts/digitalWallet')
        .then(() => {})
        .catch((error) => {
          console.error('Failed to load digitalWallet.js', error);
        });
    }
  }, [isFullSteamDigitalWalletEnabled]);

  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        {description && <meta name="description" content={description} />}
      </Helmet>
      <APIError position="layout" />
      {children}
    </>
  );
};

export default Layout;
